import EmailPassword from 'supertokens-auth-react/recipe/emailpassword';
import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { Center } from '@mantine/core';
import { AuthLayout } from '../Layouts/AuthLayout.tsx';
import { useApolloClient } from '@apollo/client';

export function Logout() {
    const [, setLocation] = useLocation();
    const client = useApolloClient();
    useEffect(() => {
        void (async () => {
            await EmailPassword.signOut();
            await client.clearStore();
            setLocation('/login');
        })();
    }, [client, setLocation]);
    return (
        <AuthLayout>
            <Center>Cerrando sesión...</Center>
        </AuthLayout>
    );
}
